const ReceiptIcon = () => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
    <g fill="currentColor" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
      <path
        d="M7 3.75h10c.69 0 1.25.56 1.25 1.25v14.2l-1.4-1-2.35 1.7-2.35-1.7-2.35 1.7-2.35-1.7L7 19.2V5c0-.69.56-1.25 1.25-1.25Z"
        fill="none"
        strokeWidth="1.5"
      />
      <path d="M8.5 7.5h7" strokeWidth="1.75" />
      <path d="M8.5 11h7" strokeWidth="1.75" />
      <path d="M8.5 14.5h5" strokeWidth="1.75" />
    </g>
  </svg>
)

export default ReceiptIcon
